import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.mandant-clear-cache';
import * as api from '../../../clients/api';

@Injectable()
export class ApiMandantClearCacheEffects {

    MandantClearCache$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_MANDANT_CLEAR_CACHE),
        mergeMap((x: ac.PostMandantClearCacheAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postMandantClearCache().pipe(
                map((result: any) => {
                    return new ac.PostMandantClearCacheErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostMandantClearCacheFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MandantenService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MandantenService {
        if (this.service === null) {
            this.service = this.injector.get(api.MandantenService);
        }
        return this.service;
    }
}
